<mat-card appearance="outlined" class="mt-3">
  <div class="d-flex justify-content-between mb-3">
    <div class="d-flex align-items-center title-container">
      <mat-icon>notes</mat-icon>
      <mat-card-title class="px-2">
        <h6 class="title-align">
          {{ 'pages.post-it-notes.root.title' | translate }}
        </h6>
      </mat-card-title>
    </div>
    <div class="d-flex justify-content-between">
      <button
        mat-icon-button
        [matTooltip]="'pages.post-it-notes.root.tooltip-add' | translate"
        (click)="onClickAddNote()"
        >
        <mat-icon>add</mat-icon>
      </button>
      <button
        mat-icon-button
        [matTooltip]="'pages.post-it-notes.root.tooltip-archived' | translate"
        (click)="onClickArchive()"
        >
        @if (archiveIconLoading) {
          <mat-spinner
            style="margin: auto"
            [diameter]="25"
          ></mat-spinner>
        }
        @if (!archiveIconLoading) {
          <mat-icon>archive</mat-icon>
        }
      </button>
    </div>
  </div>
  <mat-divider></mat-divider>
  @if (isLoading) {
    <div>
      <app-skeleton-post-it-notes
        [skeletonNotes]="2"
      ></app-skeleton-post-it-notes>
    </div>
  }
  @if (!isLoading) {
    <div>
      @if (notes?.length > 0) {
        <mat-accordion
          [multi]="true"
          cdkDropList
          (cdkDropListDropped)="drop($event)"
          class="px-1"
          >
          @for (note of notes; track note; let i = $index) {
            <mat-expansion-panel
              cdkDrag
              hideToggle
              (expandedChange)="panelExpanded($event, i)"
        [style.background]="
          note.loading ? 'transparent' : note.background_color
        "
              [ngClass]="{ 'app-border': note.loading }"
              >
              <mat-expansion-panel-header class="note-header">
                <div class="d-flex align-items-center note-header_title">
                  @if (note.loading) {
                    <div cdkDragHandle style="cursor: move">
                      <button
                        mat-icon-button
                        class="note-header_icon skeleton-loader-item"
                        disabled
                        >
                        <mat-icon></mat-icon>
                      </button>
                    </div>
                  }
                  @if (!note.loading) {
                    <div
                      cdkDragHandle
                      style="cursor: move; margin-bottom: auto"
                      >
                      <mat-icon [style.color]="note.text_color" class="drag-icon"
                        >drag_indicator</mat-icon
                        >
                      </div>
                    }
                    @if (!note.loading) {
                      <div
                        class="px-2 note-header_title_text"
                        [class.note-header_title_text]="note.collapsed"
                        [style.color]="note.text_color"
                        >
                        {{ note.title }}
                      </div>
                    }
                    @if (note.loading) {
                      <div
                        class="px-2 loading-color skeleton-title-text skeleton-loader-item"
                      ></div>
                    }
                  </div>
                  @if (!note.loading) {
                    <div
                      class="note-header_date d-flex align-items-center"
                      [style.color]="note.text_color"
                      >
                      {{ note.start_date }}
                    </div>
                  }
                  @if (note.loading) {
                    <div
                      class="skeleton-date-text d-flex align-items-center loading-color skeleton-loader-item"
                    ></div>
                  }
                </mat-expansion-panel-header>
                @if (!note.loading) {
                  <p
                    [style.color]="note.text_color"
                    class="description"
                    >
                    {{ note.description }}
                  </p>
                }
                @if (note.loading) {
                  <p
                    class="ml-2 mb-1 skeleton-note-expanded-description skeleton-loader-item"
                  ></p>
                }
                @if (note.loading) {
                  <p
                    class="ml-2 skeleton-note-expanded-description skeleton-loader-item"
                  ></p>
                }
              </mat-expansion-panel>
            }
          </mat-accordion>
        } @else {
          @if (!isLoading) {
            <app-no-results-found></app-no-results-found>
          }
        }
      </div>
    }

  </mat-card>
  <ng-keyboard-shortcuts [shortcuts]="shortcuts"></ng-keyboard-shortcuts>
